import { Tooltip } from '@mui/material';

import styled from 'styled-components';

export const PortfolioTooltip = styled(Tooltip)`
  cursor: pointer;
`;
